import { Component, OnInit, Directive, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../commons/config.service';
import { CartService } from '../commons/cart.service';
import { UtilitiesService } from '../commons/utilities.service';
import { BraintreePaymentService } from '../commons/braintree-payment.service';
import { PaymentType, DataCampionario } from '../commons/models';



@Directive({
  selector: '[ngModel][uppercase]',
  host: {
    "(input)": 'onInputChange($event)'
  }
})
export class UppercaseDirective {
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  value: any

  onInputChange($event) {
    this.value = $event.target.value.toUpperCase()
    this.ngModelChange.emit(this.value)
  }
}

declare var fbq: Function;



@Component({
  template: require('./checkout.campionario.component.html'),
  styles: [`
     .form-step-header{ color:#fff; background-color:#333; padding:8px 6px; margin:10px 0 10px;
       font-size:19px; text-transform:uppercase;}
       .step-content{ margin-bottom:20px;}
  `]

})

export class CheckoutCampionarioComponent implements OnInit {

  public get selPaymentType(): PaymentType {
    return this.cartService.cart.paymentType;
  }
  public set selPaymentType(type: PaymentType) {
    this.cartService.cart.paymentType = type;
  }

  public get selDeliveryOptionId(): number {
    return this.cartService.cart.SelDeliveryOption.id;
  }
  public set selDeliveryOptionId(id: number) {
    this.cartService.cart.SelDeliveryOption = this.config.deliveryOptions.filter(v => v.id === id)[0];
  }

  constructor(
    public config: ConfigService,
    private router: Router,
    public cartService: CartService,
    public utilities: UtilitiesService,
    private braintreePayment: BraintreePaymentService) {
  }

  ngOnInit() {

    fbq('track', 'InitiateCheckout');

    fbq('track', 'AddToCart', {
      content_ids: 99,
      content_type: 'product',
      value: this.config.campionarioPrice,
      currency: 'EUR'
    });

    //console.log('campionario init');
    this.utilities.cartTOTAL();
    this.changeStep(1);
    //console.log(this.cartService.cart);
  }

  onChange(value: string) {
    //console.log('campionario change');
    this.utilities.cartTOTAL();
  }



  isEnabled(): boolean {
    if (this.cartService.cart.checkoutStepIndex < 4) {
      return true;
    } else {
      return false;
    }
  }

  changeStep(newStep: number) {
    //console.log(this.cartService.cart.checkoutStepIndex);
    // controllo per non tornare indietro una volta arrivati al pagamento
    if (newStep < this.cartService.cart.checkoutStepIndex && this.cartService.cart.checkoutStepIndex !== 4) {
      this.cartService.cart.checkoutStepIndex = newStep;
      this.cartService.cart.paymentNonce = null;
      //console.log(newStep);
    } else {
      //console.log('tentativo di changeStep', newStep);
    }

  }

  frmShipmentSubmit(f) {
    // alert('ok ship | ' + f.value.shipmentName);
    this.cartService.cart.checkoutStepIndex = 2;
    this.cartService.saveCart();
  }

  frmInvoiceSubmit(f) {
    // alert('ok invoic | ' + f.value.name);
    if (!this.cartService.cart.billing.TaxCode && !this.cartService.cart.billing.VatNumber) {
      alert('inserire almeno Codice Fiscale o P.IVA ');
      return;
    }
    if(!!this.cartService.cart.billing.VatNumber && !this.cartService.cart.billing.CodeSDI && !this.cartService.cart.billing.PEC) {
      alert('obbligatorio il codice SDI oppure la PEC');
      return;
    }

    this.cartService.cart.checkoutStepIndex = 3;
    this.cartService.saveCart();
  }

  // frmShipmentTypeSubmit(f) {
  //   fbq('track', 'AddPaymentInfo');
  //   this.cartService.cart.checkoutStepIndex = 4;
  //   this.cartService.saveCart();
  // }

  frmPaymentTypeSubmit(f) {

    this.cartService.cart.checkoutStepIndex = 4;
    this.cartService.saveCart();

    if (this.cartService.cart.paymentType === PaymentType.Braintree) {
      this.braintreePayment.setup({
        container: 'braintree-container',
        price: this.config.campionarioPrice,
        onReady: function (integration) {
          //console.log('braintree', 'onReady');
        },
        onError: error => {
          alert('braintree - error: ' + error);
        }
      },
        onPaymentMethodReceived => {
          //console.log('braintree', 'method - onPaymentMethodReceived');
          this.cartService.cart.paymentNonce = onPaymentMethodReceived.nonce;
          this.closeCampionario(onPaymentMethodReceived.nonce);
        });
    } else {
      // BONIFICO BANCARIO
    }

  }

  frmEndCampionarioSubmit(f: HTMLFormElement) {
    // Se è Braintree lo fa sopra
    if (this.selPaymentType !== PaymentType.Braintree) {
      this.closeCampionario();
    }
  }

  closeCampionario(paymentNonce: string = null) {

    $('#mdCloseCampionario').hide();
    $('#loaderApp').show();

    let dataCampionario = new DataCampionario();
    dataCampionario.customer = this.cartService.cart.customer;
    dataCampionario.billing = this.cartService.cart.billing;
    dataCampionario.shipmentAddress = this.cartService.cart.shipmentAddress;
    dataCampionario.billingAddress = this.cartService.cart.shipmentAddress;

    dataCampionario.shippingPrice = 0;
    dataCampionario.totalPriceCampionario = this.config.campionarioPrice;
    dataCampionario.paymentType = this.cartService.cart.paymentType;
    dataCampionario.paymentNonce = paymentNonce;

    //console.log(dataCampionario);

    this.utilities.requestAngular2('cartAllCampionario', dataCampionario).subscribe(
      result => {
        //console.log(result);
        //console.log(result.Item1);
        //console.log(result.Item2);

        if (result.Item1 === 'ok') {
          $('#mdCloseCampionario').modal('hide');

          this.router.navigate(['/campionario-completed/' + result.Item2]);
        } else {
          alert('Acquisto Campionario fallito \r\n verifica tutti i dati');
          $('#loaderApp').hide();
        }
      },
      error => {
        console.error(error);
      }
    );


  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/checkout.campionario.component.ts